import React from 'react';
import map from 'lodash/map';
import 'react-image-lightbox/style.css';
import Gallery from 'react-grid-gallery';
import get from 'lodash/get';
import {useDispatch, useSelector} from "react-redux";
import {fetchUserPhotoSelect} from "../../store/users/actions";

// eslint-disable-next-line react/prop-types
export default function PhotoBox() {
    const dispatch = useDispatch();
    const { photos} = useSelector(state => state.users);
    const responseImages = () =>{
       return  map(photos, (image) => {
            return {
                isSelected:Boolean(get(image,'isSelected')),
                src: image.original_url,
                thumbnail:image.thumb_url,
                thumbnailWidth: 180,
                caption:'...',
                tags: get(image,'tags', []),
                thumbnailHeight: 120,
            }
        })
    }

    return (
        <Gallery
            images={responseImages()}
            onSelectImage={(element,photo)=>dispatch(fetchUserPhotoSelect({photo}))}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/PhotoBox/index.jsx